<template>
	<section style>
		<client-logo v-if="!isiFrame" />
		<tab-header v-if="!isiFrame" />

		<div class="page" style="padding-top: 10px">
			<div class="container large">
				<!-- If you also want to apply a transition on the initial render of a node, you can add the appear attribute: -->
				<!-- <transition mode="out-in" name="shopfade" appear> -->
				<router-view name="overview"></router-view>
			</div>
		</div>
	</section>
</template>

<script>
	import ClientLogo from '../components/ClientLogo.vue';
	import TabHeader from '../components/TabHeader.vue';
	//import CartBar from "../components/CartBar.vue";
	//import ShopActivities from "./OverviewActivities.vue";
	//import ShopPackages from "./OverviewPackages.vue";

	import { mapActions } from 'vuex';

	//import stickybits from "stickybits";

	import { mapGetters, mapState } from 'vuex';

	export default {
		data: function() {
			return {
				//showActvities: true,
				className: 'foo',
				transitionDuration: 2000,
			};
		},
		created() {
			if (
				this.$route.params.clientAgentKey &&
				!isNaN(this.$route.params.clientAgentKey)
			) {
				console.log(this.$route.params.clientAgentKey);
				this.updateClientAgentKey(Number(this.$route.params.clientAgentKey));
				// this.$route.params.clientAgentKey = 39;
			}
		},
		props: {
			/*
			serverName: {
				type: String, // to add validation
				required: true,
				default: '' // default must match the type// if typ[e string, default must be a string, if array, default must be an array
			}
*/
		},
		methods: {
			...mapActions(['updateClientAgentKey']),
		},
		computed: {
			// mix the getters into computed with object spread operator
			...mapState(['client']),
			...mapGetters(['packages']),
			isiFrame: function() {
				try {
					return window.self !== window.top;
				} catch (e) {
					return true;
				}
			},
		},

		mounted: function() {
			//stickybits(".sticky-bit", { useStickyClasses: true });
			// run an action
			//this.$store.dispatch('ajaxClientInfo');
			// GET request
			const event = new CustomEvent('si-mounted');
			document.dispatchEvent(event);
			console.log('si-mounted dispatched');
		},
		watch: {
			$route: {
				handler() {
					if (this.client && this.client.Name) {
						document.title = 'Booking | ' + this.client.Name;
					}
				},
				immediate: true,
				//deep: true
			},
			'client.Name': {
				handler() {
					if (this.client && this.client.Name) {
						document.title = 'Booking | ' + this.client.Name;
					}
				},
				immediate: true,
				//deep: true
			},
		},

		// register this component locally, not globally
		components: {
			ClientLogo,
			TabHeader,
			//CartBar,
			//CartIcon
			//"app-shop-activities": ShopActivities,
			//"app-shop-packages": ShopPackages
		},
	};
</script>

<style lang="scss" scoped></style>
